export const subscribeNavbar = [
  {
    text: "Subscribe",
    icon: "mdi-email",
    to: "/subscribe",
  },
];
